var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompBase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "408px",
    height: "78.817px",
    viewBox: "14.553 0 408 78.817",
    enableBackground: "new 14.553 0 408 78.817",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 218.553,
    cy: 59.587,
    rx: 200.398,
    ry: 15.749
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E6DD",
    d: "M125.219,49.795c0,0,14.631,0,22.388-5.625s9.209-19.75,13.686-39.375h114.521 c0,0,6.32,33.066,12.171,38.125c6.433,5.563,15.073,6,23.901,6.875v3.667H125.219V49.795z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.219,
    y: 49.795,
    fill: "#C9C6C3",
    width: 186.667,
    height: 3.667
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1DED9",
    d: "M161.258,4.795c-1.121,4.917-2.053,9.487-2.941,13.667h120.475c-1.822-7.451-3.012-13.667-3.012-13.667 H161.258z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompBase1);
export default __webpack_public_path__ + "static/media/comp_base_1.0976a9549166b103c395a2db9ea2f4d8.svg";
export { ForwardRef as ReactComponent };